module.exports = __webpack_public_path__ + "img/top-logo.efeaed8c.png";